import { render, staticRenderFns } from "./PageInductionCooktopIncentive.vue?vue&type=template&id=250670b8&scoped=true&"
import script from "./PageInductionCooktopIncentive.vue?vue&type=script&lang=js&"
export * from "./PageInductionCooktopIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250670b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('250670b8')) {
      api.createRecord('250670b8', component.options)
    } else {
      api.reload('250670b8', component.options)
    }
    module.hot.accept("./PageInductionCooktopIncentive.vue?vue&type=template&id=250670b8&scoped=true&", function () {
      api.rerender('250670b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/eicproducts/induction-cooktop/PageInductionCooktopIncentive.vue"
export default component.exports